// extracted by mini-css-extract-plugin
export default {"textCenter":"Item_textCenter__Sbh3x","textRight":"Item_textRight__eKMbz","textLeft":"Item_textLeft__kqMyV"};